module.exports = __webpack_public_path__ + "img/en.e9834b1b.svg";